<template>
  <div class="right">
    <div class="qzgl_moudle">
      <section class="qzgl_title" id="qzgl_title">
        <div v-for="(item, index) in headerList" :data-value="item.value" :key="index" @click="reds($event, index)" :class="{
            title_card_active: activeIndex == index,
          }" class="title_card">
          {{ item.name }}
        </div>
      </section>
      <section class="qzgl_content animated fadeIn">
        <img src="@/assets/images/empty.png" style="display: block; margin: 0 auto" v-if="signList.length == 0" />
        <div class="wdsc_items" v-for="(item, index) in signList" :key="index">
          <div class="wdsc_item_title">
            <div class="wdsc_item_title_content_right">
              <div class="wdsc_item_title_content_right_content1">
                <div class="wdsc_item_title_content_right_content1_m">
                  {{ item.recruitNotice.title }}
                </div>
              </div>
            </div>
          </div>
          <div class="wdsc_item_bottom">
            <div class="wdsc_item_bottom_qx" v-if="item.status == 0" @click="cancleSign(item)">
              取消报名
            </div>
            <div class="wdsc_item_bottom_td" style="margin-right: 20px" v-if="item.status == 3" @click="showSignDetail(item)">
              修改
            </div>
            <div class="wdsc_item_bottom_td" @click="showSignDetail(item)">
              查看详情
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="fenye" v-if="total > 0">
      <el-pagination @current-change="handleCurrentChange" background layout="prev, pager, next, jumper" :total="total" :page-size="search.pageSize" :current-page.sync="search.pageNum"
        @size-change="handleSizeChange">
      </el-pagination>
    </div>
    <sign-up ref="signUp" @getMySign="getMySign" :recruitId="recruitId" :showSignUp.sync="showSignUp"></sign-up>

    <!--打印-->
    <el-dialog title="打印准考证:温馨提示缩放60%打印效果更好" width="800px" :visible.sync="printVisible">
      <!-- startprint -->
      <div class="box">
        <div id="printMe" class="printMe" v-if="printVisible" ref="printMe" v-html="ticketInfo"></div>
      </div>
      <!-- startprint -->
      <div style="text-align: right">
        <el-button v-print="printObj" type="primary">直接打印</el-button>
        <el-button @click="printVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
    
    <script>
// import SignUp from "@/components/choosePostSign.vue";
import SignUp from "@/components/choosePostSign1.vue";
import SignPay from "@/components/signPay.vue";
export default {
  components: { SignUp, SignPay },
  data() {
    return {
      total: 0,
      search: {
        pageNum: 1,
        pageSize: 3,
        status: "0",
      },
      activeIndex: 0,
      signList: [
        {
          writeScore: 0,
        },
      ],
      headerList: [
        {
          name: "待提交",
          value: "0",
        },
        {
          name: "已提交",
          value: "1",
        },
      ],
      recruitId: "",
      signupId: 0,
      showSignUp: false,

      showSignPay: false,

      printVisible: false,
      ticketInfo: "",
      ticketId: "",
      printObj: {
        id: "printMe",
        popTitle: "打印",
        clickMounted: (e) => {
          // this.printVisible = false
          this.updateTicketStatus(2);
        },
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
      },
    };
  },
  activated() {
    this.getMySign();
  },
  watch: {
    printVisible: function (val) {
      console.log(val, "val");
      if (!val) {
        // this.updateTicketStatus(2);
      }
    },
  },
  methods: {
    reds(e, index) {
      let _this = this;
      _this.activeIndex = index;
      _this.signList = [];
      let value = e.target.dataset.value;
      if (value == "ms") {
        _this.search.interviewStatus = 2;
        delete _this.search.status;
        delete _this.search.writtenExaminationStatus;
      } else if (value == "bs") {
        _this.search.writtenExaminationStatus = 2;
        delete _this.search.status;
        delete _this.search.interviewStatus;
      } else {
        _this.search.status = e.target.dataset.value;
      }

      _this.getMySign();
    },
    handleCurrentChange(val) {
      console.log(`000每页 ${val} 条`);
      let _this = this;
      _this.search.pageNum = val;
      _this.getMySign();
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    getMySign() {
      let _this = this;
      _this.$api.choosePostRecruitNotice
        .getChoosePostSignList(_this.search)
        .then((res) => {
          if (res.code == _this.$commons.RespCode.success) {
            _this.signList = res.rows;
            _this.total = Number(res.total);
          }
        })
        .catch(() => {});
    },
    cancleSign(item) {
      let _this = this;
      let param = {
        id: item.id,
      };
      _this.$layer.confirm(
        "确定要取消此报名吗?",
        {
          btn: ["确定", "取消"], // 按钮
        },
        function (index) {
          _this.$api.choosePostRecruitNotice
            .cancelSignInfo(param)
            .then((res) => {
              if (res.code == _this.$commons.RespCode.success) {
                _this.$layer.alert("操作成功!");
                _this.getMySign();
              }
            })
            .catch(() => {});
          _this.$layer.close(index);
        },
        function (index) {
          _this.$layer.close(index);
        }
      );
    },
    showSignDetail(item) {
      console.log("item", item);
      let _this = this;
      _this.recruitId = String(item.recruitId);
      _this.showSignUp = true;
      _this.$refs.signUp.showSignUp = true;
      _this.$refs.signUp.getNoticeInfoById(item.recruitId);
      _this.$refs.signUp.getSignUpById(item.id);

      // _this.$refs.signUp.getPostList();
    },

    updateTicketStatus(status) {
      let _this = this;
      _this.$api.ticket
        .updateTicketStatus({ id: _this.ticketId, printStatus: status })
        .then((response) => {});
    },
  },
};
</script>
    <style>
.tongguo {
  color: green !important;
}

.jujue {
  color: red !important;
}

.box {
  height: 600px;
  overflow-y: scroll;
}

.printMe {
  height: auto;
}

.printMe table {
  width: 100%;
}
</style>
    


// WEBPACK FOOTER //
// src/view/mine/mineChoosePostSign.vue